module.exports = __webpack_public_path__ + "static/media/Grinning Face Emoji.H01.2k.e711d275.png";